import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import SideMenu from "components/admin/layout/SideMenu";

const AdminPhotoSeries: React.FC = () => {
  return (
    <Page>
      <FullWidth>
        <div className="row">
          {/* SIDE MENU */}
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12">
            <SideMenu />
          </div>

          {/* CENTRAL CONTENT */}
          <div
            className="col-comp-central col-xl-10 col-lg-9 col-md-9 col-sm-12 offset-xl-1 offset-lg-1 offset-md-1"
            style={{ marginLeft: "15%", marginTop: "-12%" }}
          >
            <Content>
              <ContentInner>
                <NewItem>
                  <RouterLink to="/admin-dashboard/photo-series-edit">
                    novo
                  </RouterLink>
                </NewItem>
                <ItemBlock>
                  <InlineLinks>
                    <a href="/admin-dashboard/photo-ser-edit/5d8dfb5a8246e7ca3c561e70">
                      <LinkSpan>polja</LinkSpan>
                    </a>
                    <a href="/admin-dashboard/photo-ser-edit-ph/5d8dfb5a8246e7ca3c561e70">
                      <LinkSpan marginLeft="2%">foto</LinkSpan>
                    </a>
                  </InlineLinks>
                  <br />
                  <Title>
                    Tokovi umetničkog nadahnuća- Đorđe Crnčević, Kuća legata,
                    25. 11 - 20.12.2015.(pozivnica)
                  </Title>
                  <br />
                  <Delete>obriši</Delete>
                </ItemBlock>

                <ItemBlock>
                  <InlineLinks>
                    <a href="/admin-dashboard/photo-ser-edit/5d8dfb5a8246e7ca3c561e71">
                      <LinkSpan>polja</LinkSpan>
                    </a>
                    <a href="/admin-dashboard/photo-ser-edit-ph/5d8dfb5a8246e7ca3c561e71">
                      <LinkSpan marginLeft="2%">foto</LinkSpan>
                    </a>
                  </InlineLinks>
                  <br />
                  <Title>
                    Gotfrid Helnvajn, Galerija - legat Milice Zorić i Rodoljuba
                    Čolakovića, 6.11.2015 - 18.01.2016.(pozivnica)
                  </Title>
                  <br />
                  <Delete>obriši</Delete>
                </ItemBlock>

                <ItemBlock>
                  <InlineLinks>
                    <a href="/admin-dashboard/photo-ser-edit/5d8dfb5a8246e7ca3c561e72">
                      <LinkSpan>polja</LinkSpan>
                    </a>
                    <a href="/admin-dashboard/photo-ser-edit-ph/5d8dfb5a8246e7ca3c561e72">
                      <LinkSpan marginLeft="2%">foto</LinkSpan>
                    </a>
                  </InlineLinks>
                  <br />
                  <Title>Otvaranje Muzeja</Title>
                  <br />
                  <Delete>obriši</Delete>
                </ItemBlock>
              </ContentInner>
            </Content>
          </div>
        </div>
      </FullWidth>
    </Page>
  );
};

export default AdminPhotoSeries;

const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

const FullWidth = styled.div`
  width: 100%;
`;

// const Header = styled.header`
//   display: flex;
//   align-items: center;
// `;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const NewItem = styled.div`
  margin-top: 0;
`;

const ItemBlock = styled.div`
  float: left;
  clear: both;
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const InlineLinks = styled.div`
  display: inline;
`;

const LinkSpan = styled.span<{ marginLeft?: string }>`
  margin-left: ${({ marginLeft }) => marginLeft || "0%"};
`;

const Delete = styled.span`
  margin-left: 0%;
  cursor: pointer;
  color: darkgrey;
`;

const Title = styled.div`
  font-size: 14px;
  line-height: 1.4;
`;
